/**
 * CrewView.js
 *
 * Renders the movie word for crewmates.
 */

import React from "react";

const CrewView = ({ movie }) => {
    return (
        <div className="flex flex-col items-center justify-center text-center">
            <p className="text-zinc-400 text-lg mb-2">Your team's movie is:</p>
            <h1 className="text-3xl sm:text-5xl font-bold text-sky-400">
                {movie || "Loading..."}
            </h1>
        </div>
    );
};

export default CrewView;